/* unplugin-vue-components disabled */import script from "./AppSortDialog.vue?vue&type=script&setup=true&name=AppSortDialog&lang=js"
export * from "./AppSortDialog.vue?vue&type=script&setup=true&name=AppSortDialog&lang=js"

import "./AppSortDialog.vue?vue&type=style&index=0&id=e5b12878&lang=scss&scoped=true"
import "./AppSortDialog.vue?vue&type=style&index=1&id=e5b12878&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e5b12878"]])

export default __exports__